import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventOriginEnum } from '@app/core/enums/analytics/analytics-value.enum';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { Work, WorkInput } from '@app/core/model/entities/works/work';
import { Section } from '@app/core/model/other/field-config';
import { FormStateService } from '@app/shared/components/form-builder/form-state.service';
import { GeneratesObject } from '@app/shared/interfaces/generates-object';
import { ValidationService } from '@app/shared/services/validation.service';
import { AccessManager } from '@services/managers/access.manager';
import { SectionService } from '@services/section.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'work-create-modal',
  templateUrl: './work-create-modal.component.html',
  providers: [FormStateService, ValidationService],
  standalone: false
})
export class WorkCreateModalComponent implements OnInit, GeneratesObject {
  public formId = 'work_creation_dialog';
  protected readonly EntityTypeEnum = EntityTypeEnum;

  protected eventsOrigin = EventOriginEnum.SHEET;
  public Permission = PermissionEnum;
  public permissionsForEdition = [PermissionEnum.CREATE_WORK];
  protected missingRequiredFields$: Observable<{ code: string, label: string }[]>;
  protected form: Section[];

  // Data
  protected workInput: WorkInput;

  protected formStateService = inject(FormStateService);
  protected accessManager = inject(AccessManager);
  private sectionService = inject(SectionService);
  protected destroyRef = inject(DestroyRef);

  /**
   * Fetch possible values for state and accessible Assets and Spaces.
   */
  public ngOnInit(): void {
    this.missingRequiredFields$ = this.sectionService.getSectionsByFormCode(this.formId).pipe(
      tap(sections => this.form = sections),
      map(sections => sections.first()),
      map(section => this.sectionService.missingRequiredFields(section)),
      takeUntilDestroyed(this.destroyRef)
    );

    this.formStateService.saved$
      .pipe(
        tap(({ data }) => {
          Work.transformPropertiesForInput(data);
          this.workInput = data;
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  /**
   * Data from the filled form.
   * @return Work data.
   */
  public getGeneratedObject(): WorkInput {
    return this.workInput;
  }
}
